import {BaseAttribute} from "@/pages/AppPages/Events/attribute";
import {required} from "vuelidate/lib/validators";

export class KeepingEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)

        this.address = null;
        this.addressHumanReadable = null;
        this.addressObject = {};
        this.forLife = false;
        this.lat = null;
        this.lon = null;

        if (initObjectParams) {
            this.forLife = initObjectParams.forLife;
            this.address = initObjectParams.address;
            this.addressHumanReadable = initObjectParams.addressHumanReadable;
            this.addressObject = initObjectParams.addressObject;
            this.lat = initObjectParams.lat;
            this.lon = initObjectParams.lon;
        }
    }

    static get modelName() {
        return 'KeepingEvent'
    }

    static get validations() {
        return {
            forLife: {},
            address: { required },
            lat: {},
            lon: {}
        }
    }

    static get validationFieldLabels() {
        return {
            forLife: 'Пожизненно',
            address: 'Источник поступления'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    get coordinates() {
        return { lat: this.lat, lon: this.lon }
    }

    applyData(data) {
        this.forLife = data['forLife'];
        this.address = data['address'];
        this.addressObject = data['address_object'];
        this.addressHumanReadable = this.addressObject ? this.addressObject['human_readable_address'] : null;
        this.lat = data['lat'];
        this.lon = data['lon'];
    }

}